import { ClubPage } from "components/ClubPage"
import { useTranslator } from "components/Translator"
import { Wrapper } from "components/Wrapper"
import { Text } from "components/Text"
import { ProductCard } from "domains/product/ProductCard"
import { RawLink } from "components/Link"
import { Pagination } from "components/Pagination"
import { useRouter } from "components/Router"
import * as ProductType from "enums/ProductType"
import { Tab, TabList, Tabs } from "components/Tab"

export function ClubProductIndexPage({ products, pagination, type }) {
  const translator = useTranslator()
  const router = useRouter()

  const tabs = [
    {
      label: translator.trans("club.product.index.tabs.all", null, "pages"),
      id: "all",
      href: router.generate("app_club_shop_product_index"),
      isCurrent: type === null,
    },
    {
      label: translator.trans("club.product.index.tabs.product", null, "pages"),
      id: "product",
      href: router.generate("app_club_shop_product_index", {
        type: ProductType.PRODUCT,
      }),
      isCurrent: type === ProductType.PRODUCT,
    },
    {
      label: translator.trans("club.product.index.tabs.benefit", null, "pages"),
      id: "benefit",
      href: router.generate("app_club_shop_product_index", {
        type: ProductType.BENEFIT,
      }),
      isCurrent: type === ProductType.BENEFIT,
    },
    {
      label: translator.trans(
        "club.product.index.tabs.flotilla",
        null,
        "pages",
      ),
      id: "flotilla",
      href: router.generate("app_club_shop_product_index", {
        type: ProductType.FLOTILLA,
      }),
      isCurrent: type === ProductType.FLOTILLA,
    },
  ]

  return (
    <ClubPage
      title={translator.trans("club.product.index.title", null, "pages")}
    >
      <Wrapper>
        <div className="space-y-6">
          <Tabs
            currentPanel={tabs.find((tab) => tab.isCurrent).id}
            onChange={() => null}
          >
            <TabList>
              {tabs.map((tab) => {
                return (
                  <Tab
                    key={tab.label}
                    label={tab.label}
                    id={tab.id}
                    href={tab.href}
                  />
                )
              })}
            </TabList>
          </Tabs>
          {products.length > 0 ? (
            <section className="space-y-10">
              <div className="grid grid-cols-2 gap-2 md:grid-cols-3 md:gap-3 lg:grid-cols-4 lg:gap-4">
                {products.map((product) => (
                  <RawLink
                    key={product.id}
                    href={{
                      route: "app_club_shop_product_show",
                      params: { productId: product.id },
                    }}
                    title={product.title}
                  >
                    <ProductCard product={product} />
                  </RawLink>
                ))}
              </div>
              <div className="flex justify-center">
                <Pagination
                  currentPageNumber={pagination.currentPageNumber}
                  itemNumberPerPage={pagination.itemNumberPerPage}
                  totalItemCount={pagination.totalItemCount}
                  pageParameterName="page"
                  pageRange={2}
                />
              </div>
            </section>
          ) : (
            <Text tag="p" variant="body2">
              {translator.trans("club.product.index.empty", null, "pages")}
            </Text>
          )}
        </div>
      </Wrapper>
    </ClubPage>
  )
}
